import React, { useState } from 'react';
import { PASSWORD_RULES } from '../constants/options';

/**
 * Password input with show/hide toggle and an optional strength checklist.
 */
const PasswordField = ({
    name,
    label,
    value,
    onChange,
    error,
    required,
    showRules = false,
    autoComplete = 'current-password',
    ...rest
}) => {
    const [visible, setVisible] = useState(false);
    const id = `psp-${name}`;
    const current = value || '';

    return (
        <div className="psp-field">
            {label && (
                <label className="psp-field__label" htmlFor={id}>
                    {label}
                    {required && <span className="psp-required">*</span>}
                </label>
            )}
            <div className="psp-password">
                <input
                    id={id}
                    name={name}
                    type={visible ? 'text' : 'password'}
                    value={current}
                    onChange={(event) => onChange(name, event.target.value)}
                    className={`psp-input${error ? ' psp-input--invalid' : ''}`}
                    aria-invalid={!!error}
                    aria-describedby={error ? `${id}-error` : undefined}
                    autoComplete={autoComplete}
                    required={required}
                    {...rest}
                />
                <button
                    type="button"
                    className="psp-password__toggle"
                    onClick={() => setVisible((v) => !v)}
                    aria-label={visible ? 'Ocultar senha' : 'Mostrar senha'}
                >
                    <i className={`fas ${visible ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true" />
                </button>
            </div>
            {showRules && (
                <ul className="psp-password-rules" aria-label="Requisitos da senha">
                    {PASSWORD_RULES.map((rule) => (
                        <li key={rule.key} className={rule.test(current) ? 'is-valid' : ''}>
                            {rule.test(current) ? '✓' : '○'} {rule.label}
                        </li>
                    ))}
                </ul>
            )}
            {error && (
                <span id={`${id}-error`} className="psp-field__error" role="alert">
                    {error}
                </span>
            )}
        </div>
    );
};

export default PasswordField;
